import { observable } from "mobx";
import { DeliveryRule } from './DeliveryRule';

export class NewContractedCustomer {
    @observable id: string;
    @observable fullName: string;
    @observable contactPerson: string;
    @observable taxId: string;
    @observable registrationId: string;
    @observable phoneNumber: string;
    @observable email: string;
    @observable deliveryAddress: string;
    @observable customerDeliveryRules: Array<DeliveryRule>;
    @observable vendorSalesRepId: string;
    @observable paymentTerms: string;
    @observable address: string;
    @observable city: string;
    @observable postalCode: string;

    constructor() {
        this.id = "";
        this.fullName = "";
        this.contactPerson = "";
        this.taxId = "";
        this.registrationId = "";
        this.phoneNumber = "";
        this.email = "";
        this.deliveryAddress = "";
        this.customerDeliveryRules = [];
        this.vendorSalesRepId = "";
        this.paymentTerms = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
    }
}